{
  "slug": "how-is-iq-measured",
  "title": "كيف يقاس معدل الذكاء؟",
  "description": "فهم اختبار الذكاء الموحد، والمعايير القائمة على العمر، والاختبارات الفرعية، والمئويات، ولماذا كل نتيجة لها هامش خطأ.",
  "summary": "ويقاس معدل الذكاء باستخدام مهام معرفية موحدة. ويقارن الأداء الخام بالمعايير القائمة على العمر ويحول إلى درجة، تركز عادة على 100 نقطة.100.",
  "sections": [
    {
      "heading": "من المهام إلى الدرجة الموحدة",
      "paragraphs": [
        "يحتوي التقييم على اختبارات فرعية متعددة. فقد يحدد الشخص أنماطاً، أو يتلاعب بالمعلومات في الذاكرة، أو يحل مشاكل لفظية، أو يعمل بدقة في حدود زمنية. والمجاميع الخام لا تعني شيئاً كثيراً بمفردها، لذا يقارنها الناشرون بعينة مرجعية كبيرة.",
        "ويقارن الأداء مع الأشخاص في نفس الفئة العمرية، ويمكن بعد ذلك دمج درجات الاختبار الفرعي المدرجة في درجات مؤشرات أوسع نطاقاً وفي تقدير عام."
      ]
    },
    {
      "heading": "المعايير والمئويات والانتشار",
      "paragraphs": [
        "ويستخدم العديد من الاختبارات الحالية متوسطا قدره. 100 و انحراف معياري قدره. 15. يعبر المئيني عن الموضع: 100 قريبة من 50المئين الثامن، بينما 120 هو حول 91المئين الأول في ظل توزيع عادي.",
        "وتستخدم الأدوات المختلفة مهام ومعايير مختلفة، وبالتالي فإن اختبارين صحيحين لا ينتجان دائما درجات متطابقة."
      ]
    },
    {
      "heading": "لماذا الترجمة الشفوية مهمة",
      "paragraphs": [
        "إن كل علامة تتضمن عدم يقين في القياس وينبغي أن تبلغ عادة مع فترة ثقة. وينظر الممتحن المدرب أيضاً في أنماط الاختبار الفرعية، واللغة، والخلفية الثقافية، وظروف الاختبار، والغرض من التقييم.",
        "إن القياس الجيد يعتمد على التعليمات القياسية، والمعايير المناسبة، وأمن الاختبار، والموثوقية، والصحة. والواقع أن الأرقام التي لا تستند إلى هذا السياق قد تكون مضللة."
      ]
    }
  ],
  "faqs": [
    {
      "question": "لماذا بعض مهام الذكاء دقيقة؟",
      "answer": "وبعض الاختبارات الفرعية تقيس كفاءة المعالجة، ولكن العديد من مهام التفكير ليست محددة زمنيا أو لها حدود سخية. والتوقيت ليس سوى جزء واحد من التقييم."
    },
    {
      "question": "هل يمكن لاختبارات ذكاء مختلفة أن تعطي نتائج مختلفة؟",
      "answer": "نعم، يمكن أن تسبب المحتويات والمعايير وخطأ القياس والصحة وظروف الاختبار اختلافات معقولة."
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
